import { roles } from '../utils/roles';
import routes from '../utils/routes';

const routeControl = {
    login: {
        default: routes.login,
        [routes.login]: routes.login,
        [routes.resetPassword]: routes.resetPassword,
        [routes.changePassword]: routes.changePassword
    },
    [roles[1]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.userManagement]: routes.userManagement,
        [routes.addUser]: routes.addUser,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[2]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.massUpdate]: routes.massUpdate,
        [routes.editProfile]: routes.editProfile,
        [routes.documentRequests]: routes.documentRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[3]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.editProfile]: routes.editProfile,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[4]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[5]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[6]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[7]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.kycCounterPartyList]: routes.kycCounterPartyList,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[8]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.settings]: routes.settings,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[9]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDropdowns]: routes.entityDropdowns,
        [routes.entityFileTypes]: routes.entityFileTypes,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entityTenors]: routes.entityTenors,
        [routes.entityTraders]: routes.entityTraders,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[10]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[11]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[12]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[13]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[14]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[15]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[16]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[17]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entitySBLC]: routes.entitySBLC,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.periodLockRequests]: routes.periodLockRequests,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.massUpdate]: routes.massUpdate,
        [routes.documentRequests]: routes.documentRequests,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[18]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycNewKYC]: routes.kycNewKYC,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycEditKYC]: routes.kycEditKYC,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[19]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.dealFertilizers]: routes.dealFertilizers,
        [routes.dealFoods]: routes.dealFoods,
        [routes.dealMiscellaneous]: routes.dealMiscellaneous,
        [routes.dealPetrochemicals]: routes.dealPetrochemicals,
        [routes.dealPolymers]: routes.dealPolymers,
        [routes.dealSBLC]: routes.dealSBLC,
        [routes.entityBanks]: routes.entityBanks,
        [routes.entityCounterParties]: routes.entityCounterParties,
        [routes.entityDeals]: routes.entityDeals,
        [routes.entityDealPFIs]: routes.entityDealPFIs,
        [routes.entityDropdowns]: routes.entityDropdowns,
        [routes.entityFileTypes]: routes.entityFileTypes,
        [routes.entityProducts]: routes.entityProducts,
        [routes.entityTenors]: routes.entityTenors,
        [routes.entityTraders]: routes.entityTraders,
        [routes.reportDealReport]: routes.reportDealReport,
        [routes.reportPreShipmentReport]: routes.reportPreShipmentReport,
        [routes.reportFinanceReport]: routes.reportFinanceReport,
        [routes.reportMorningReport]: routes.reportMorningReport,
        [routes.reportTreasuryReport]: routes.reportTreasuryReport,
        [routes.reportDocuments]: routes.reportDocuments,
        [routes.kycRequests]: routes.kycRequests,
        [routes.kycRequestsDetails]: routes.kycRequestsDetails,
        [routes.kycCounterPartyList]: routes.kycCounterPartyList,
        [routes.approveDocuments]: routes.approveDocuments,
        [routes.approveDocumentsDetails]: routes.approveDocumentsDetails,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    },
    [roles[20]]: {
        default: routes.landing,
        [routes.setNewPassword]: routes.setNewPassword,
        [routes.auditTrailFinance]: routes.auditTrailFinance,
        [routes.auditTrailUser]: routes.auditTrailUser,
        [routes.editProfile]: routes.editProfile,
        [routes.pageNotFound]: routes.pageNotFound
    }
};

export default routeControl;

export const getDefaultPage = (role) => {
    const roleAccess = routeControl[role];
    return roleAccess?.default || null;
};